<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <b-img
          fluid
          src="@/assets/images/logo/Udara360-logo.png"
          width="180"
        />
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex p-0"
      >
        <div
          v-if="institution.loginPageBackgroundURL"
          class="auth-bg-image"
          role="img"
          aria-label="Institution background"
          :style="{
            backgroundImage: 'url(' + institution.loginPageBackgroundURL + ')',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            width: '100%',
            height: '100%',
          }"
        />
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            class="mb-1"
            style="text-align: center;"
          >
            Unverified System Access
          </b-card-title>
          <b-card-text class="mb-3">
            We've noticed that this device has not been verified to access our system. Please use the request button below to apply.
          </b-card-text>

          <!-- form -->
          <Alert
            :show="showFormError"
            :message="errorMessage"
          />
          <!-- submit button -->
          <p
            class="m-1"
            style="text-align: center"
          >
            <b-form
              @submit.prevent="systemAccessRquest"
            >
              <Button
                label="Request Access"
                :loading="isLoading"
                :disabled="isDisabled"
                size="lg"
                block
                @click="systemAccessRquest"
              />
            </b-form>
          </p>

          <b-card-text class="text-center mt-2">
            <b-link :to="{name:'auth-login'}">
              <feather-icon icon="ChevronLeftIcon" /> Back to login
            </b-link>
          </b-card-text>
        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import {
  BRow, BCol, BLink, BCardText, BCardTitle, BImg, BForm,
} from 'bootstrap-vue'
import { required } from '@validations'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { toastAlert } from '@core/mixins/toast'
import { mapActions, mapGetters } from 'vuex'
import FingerprintJS from '@fingerprintjs/fingerprintjs-pro'
import Button from '../../components/button/Button.vue'
import Alert from '../../components/alert/Alert.vue'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    Button,
    Alert,
  },
  mixins: [toastAlert, sweetAlert],
  data() {
    return {
      userDetails: {
        email: '',
        password: '',
        requestID: '',
      },
      isLoading: false,
      isDisabled: false,
      showFormError: false,
      errorMessage: '',
      required,
    }
  },
  computed: {
    ...mapGetters({
      institution: 'auth/getInstitution',
    }),
  },
  mounted() {
    this.getUser()
  },
  methods: {
    ...mapActions({
      systemAccessRequest: 'auth/systemAccessRequest',
    }),
    getUser() {
      const { user } = this.$route.params
      if (user) {
        this.userDetails.email = user.username
        this.userDetails.password = user.password
      } else {
        this.$router.push({ name: 'auth-login' })
      }
    },
    systemAccessRquest() {
      try {
        this.showFormError = false
        this.isDisabled = true
        this.isLoading = true
        // Initialize an agent at application startup.
        const fpPromise = FingerprintJS.load({
          apiKey: 'FshXOiyrz3LRwMoLnXsG',
          endpoint: [
            'https://fingerprint.udara360.io',
            FingerprintJS.defaultEndpoint, // The default endpoint as fallback
          ],
          scriptUrlPattern: 'https://fingerprint.udara360.io/web/v<version>/<apiKey>/loader_v<loaderVersion>.js',
        })
        // Get the visitor identifier when you need it.
        fpPromise
          .then(fp => fp.get({ extendedResult: true }))
        // eslint-disable-next-line consistent-return
          .then(async result => {
            // This is the visitor identifier:
            this.userDetails.requestID = result.requestId
            const response = await this.systemAccessRequest(this.userDetails)
            const { status } = response
            if (status === 200) {
              this.alertSuccess({ text: 'Your have successfully logged a system access request for approval. You will be able to log-in once the request is approved' })
              this.$router.push({ name: 'auth-login' })
            }
          })
      } catch (error) {
        error.response.data.errors.forEach(responseError => {
          this.errorMessage = responseError.errorMessage
        })
        this.showFormError = true
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
